import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {

  constructor(private _httpClient: HttpClient) { }
  private _userUrl = environment.runtime.userManagementApiUrl;

  /**
   * Get announcement with page and limit
   * @param page
   * @param limit
   */
  public getAnnouncemnts(organizationType: string, page: number = 1, limit: number = 10) {
    if (!organizationType) throw Error('Organization type Not found!!');
    const filter = {
      filters: {
        organizationType: organizationType
      },
      meta: {
        pagination: {
          limit: limit,
          page: page
        }
      }
    }

    return this._httpClient.post(`${this._userUrl}/announcements`, filter);
  }

  /**
   * Update Announcement with new data
   * make call to api update
   * @param id
   * @param announcementData
   * @param expirationDate
   */
  public updateAnnouncement(_id: string, announcementData: any, organizationType: string) {
    if (!announcementData) throw Error('announcementData not provided.');
    const data = {
      announcement: announcementData.announcemntText,
      organizationType: organizationType,
      expirationDateTime: announcementData.expirationDateTime,
      priority: announcementData.priority
    };

    if (_id) {
      // if we have id its organizationId call update api
      return this._httpClient.put(`${this._userUrl}/announcement/${_id}`, data);
    } else {
      // else call create api
      return this._httpClient.post(`${this._userUrl}/announcement/create`, data);
    }
  }

  /**
   * Remove announcement from announcements
   * @param id
   */
  public removeAnnouncemnt(_id: string) {
    if (!_id) throw Error('id is not provided.');
    return this._httpClient.delete(`${this._userUrl}/announcement/${_id}`);
  }

  /**
   * Get single announcement based on id
   * @param announcementId
   */
  public getAnnouncement(announcementId: string) {
    return this._httpClient.get(`${this._userUrl}/announcement/${announcementId}`).toPromise();
  }

}
